import moment, { months } from "moment";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { FaClock, FaListAlt, FaRegClock } from "react-icons/fa";
import { Link } from "react-router-dom";
import "moment/locale/id";
import { slicingWord } from "utils/slicingWord";
import { PaginationPortal } from "components";
import { useDispatch, useSelector } from "react-redux";
import {
  API_URL_kbArticleRelationship,
  API_URL_kbSetting,
} from "constants/api";
import { kbArticleRelationshipReducers } from "redux/kbArticleRelationshipSlice";
import { getData } from "actions";
import { kbSettingReducers } from "redux/kbSettingSlice";
import { RiCollageLine } from "react-icons/ri";
import { AuthContext } from "context/AuthContext";

const KnowledgeBase = ({ category, search }) => {
  moment.locale("id");
  const dispatch = useDispatch();
  const { paginateKb } = useContext(AuthContext);
  const { getKbArticleRelationshipResult } = useSelector((state) => ({
    getKbArticleRelationshipResult:
      state.kbArticleRelationship.getKbArticleRelationshipResult,
  }));
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [limit, setLimit] = useState(paginateKb.pagination);

  const getKbArticleRelationship = useCallback(
    async (params) => {
      getData(
        API_URL_kbArticleRelationship,
        params,
        { dispatch, redux: kbArticleRelationshipReducers },
        "GET_KBARTICLERELATIONSHIP"
      );
    },
    [dispatch]
  );

  const handlePageClick = ({ selected }) => {
    const newOffset = selected * limit;
    const params = `?limit=${limit}&offset=${newOffset}&category_id=${category}&search=${search}`;
    setOffset(newOffset);
    setCurrentPage(selected);
    getKbArticleRelationship(params);
  };

  const fetchData = useCallback(() => {
    const params = `?limit=${limit}&offset=${offset}`;
    getKbArticleRelationship(params);
  }, [limit, offset]);

  useEffect(() => {
    if (category === "" && search === "") fetchData();
  }, []);

  useEffect(() => {
    if (category) {
      //RESET PAGINATE KE 1
      setCurrentPage(0);
      const params = `?limit=${limit}&offset=${0}&category_id=${category}`;
      getKbArticleRelationship(params);
    }
  }, [category]);
  useEffect(() => {
    if (search) {
      //RESET PAGINATE KE 1
      setCurrentPage(0);
      const params = `?limit=${limit}&offset=${0}&search=${search}`;
      getKbArticleRelationship(params);
    }
  }, [search]);

  return (
    <div className="w-full mx-4 text-gray-800 ">
      {getKbArticleRelationshipResult.results &&
        getKbArticleRelationshipResult.results.map((item, index) => (
          <div key={index}>
            <div id="Content" key={index} className="mb-4">
              <div className="flex items-center mb-1">
                <FaListAlt className="mr-2 text-gray-500" />
                <Link
                  to={`/pertanyaan/${item.article.slug}`}
                  state={{
                    category: category,
                    category_name: item.category_name,
                  }}
                  className="text-xl font-bold text-sky-500 hover:text-sky-600"
                >
                  {item.article.name}
                </Link>
              </div>
              <div className="ml-6 px-5 pt-1 bg-gray-100 border-l-4 border-l-gray-300">
                <div
                  className="text-left ck-editor-content"
                  dangerouslySetInnerHTML={{
                    __html: slicingWord(item.article.description, 430),
                  }}
                ></div>
                <div className="text-left">
                  <Link
                    to={`/pertanyaan/${item.article.slug}`}
                    state={{
                      category: category,
                      category_name: item.category_name,
                    }}
                    className="text-sky-500 text-left hover:underline"
                  >
                    Read More
                  </Link>
                </div>
              </div>
              <div className="ml-6 px-5 pt-1 flex items-center">
                <FaRegClock className="text-gray-600 mr-1" />
                <span className="text-xs text-gray-600">
                  {moment(item.article.updated_at).format("dddd, D MMMM YYYY")}
                </span>
              </div>
            </div>
          </div>
        ))}
      <PaginationPortal
        handlePageClick={(e) => handlePageClick(e)}
        pageCount={
          getKbArticleRelationshipResult.count > 0
            ? getKbArticleRelationshipResult.count
            : 0
        }
        limit={limit}
        offset={offset}
        currentPage={currentPage}
      />
    </div>
  );
};

export default KnowledgeBase;
